import { View } from "react-native-ui-lib";
import { Page } from "@towersystems/roam-common-native";

export const ResetTyroSimulationScreen = () => {
  return <Page></Page>;
};
